<template>
  <div class="early-warning">
    <Badge :count="errorCount">
      <Button type="text" class="demo-badge" @click="openEarlyWarningPage" >
        <Icon :size="20" :color="color" type="md-notifications"/>
      </Button>
    </Badge>
  </div>
</template>

<script>
import { getTodoLogsCnt } from '_api/iot/modules/warning-api.js'
export default {
  name: 'early-warning',
  props: {
    color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      websock: null,
      errorCount: 0,
      timer: ''
    }
  },
  created () {
    // this.initWebSocket()
  },
  destroyed () {
    if (this.websock) {
      this.websock.close()
    }
  },
  methods: {
    getTodoLogsCnt () {
      getTodoLogsCnt().then((res) => {
        if (res && res.data) {
          this.errorCount = res.data
        }
      })
    },
    openEarlyWarningPage () {
      this.$router.push({
        name: 'device_earlywarning'
      })
    },
    // 初始化weosocket
    initWebSocket () {
      const wsuri = this.$config.webSocket + this.$store.state.user.userName
      // 不是空的先关闭
      if (this.websock) {
        this.websock.close()
      }
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    // 连接建立之后执行send方法发送数据
    websocketonopen () {
      this.websocketsend()
    },
    // 连接建立失败重连
    websocketonerror () {
      // this.initWebSocket()
    },
    // 数据接收
    websocketonmessage (e) {
      this.$Notice.error({
        title: '错误数据',
        desc: e.data
      })
    },
    // 数据发送
    websocketsend (Data) {
      this.websock.send(Data)
    },
    // 关闭
    websocketclose (e) {
      console.log('WebSocket断开连接', e)
    }
  },
  mounted () {
    // this.getTodoLogsCnt()
    // this.timer = setInterval(this.getTodoLogsCnt, 60000)
  },
  beforeDestroy () {
    // clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped="scoped">
.early-warning{
  margin-right: 12px;
  .ivu-badge-dot{
    top: 20px;
  }
  .ivu-btn.ivu-btn-text{
    padding: 5px 1px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/components/early-warning/early-warning.vue